import { render, staticRenderFns } from "./HSchool.vue?vue&type=template&id=7c3df943&scoped=true&"
import script from "./HSchool.vue?vue&type=script&lang=js&"
export * from "./HSchool.vue?vue&type=script&lang=js&"
import style0 from "./HSchool.vue?vue&type=style&index=0&id=7c3df943&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3df943",
  null
  
)

export default component.exports